import React from 'react';
import { TextInput, DateInput, ReferenceInput, AutocompleteInput, BooleanInput, FormDataConsumer, usePermissions, required } from 'react-admin';
import moment from 'moment';

import Create, { CreateActions } from '../common/views/Create';
import SimpleForm from '../common/forms/SimpleForm';
import TypeInput from './inputs/TypeInput';
import DurationInput from './inputs/DurationInput';
import HelpButton from './buttons/HelpButton';

const userOptionText = choice => choice?.fullname ? choice.fullname : '';

const validateLeave = (values) => {
    const errors = {};

    if (!moment(values.start_date).isSame(values.end_date, 'month')) {
        errors.start_date = 'Must be from the same month';
        errors.end_date = 'Must be from the same month';
    }
    if (!values.type) {
        errors.type = 'ra.validation.required';
    }
    if (!values.start_date) {
        errors.type = 'ra.validation.required';
    }
    if (!values.end_date) {
        errors.type = 'ra.validation.required';
    }

    return errors;
};

const LeaveActions = () => (
    <CreateActions>
        <HelpButton />
    </CreateActions>
);

const LeaveCreate = ({ defaultValues, ...props }) => {
    const { permissions } = usePermissions();

    return (
        <Create {...props} redirect="list" actions={<LeaveActions />}>
            <SimpleForm validate={validateLeave} defaultValues={defaultValues}>
                {permissions?.includes('is_admin') && (
                    <ReferenceInput source="user_id" reference="users" sort={{ field: 'id', order: 'ASC' }}>
                        <AutocompleteInput optionText={userOptionText} size="small" />
                    </ReferenceInput>
                )}
                <TypeInput validate={required()} />
                <DateInput source="start_date" validate={required()} />
                <DateInput source="end_date" validate={required()} />
                <FormDataConsumer>
                    {({ formData }) => (
                        (formData.duration <= 1 && formData.duration > 0) && (
                            <BooleanInput source="half_day" />
                        )
                    )}
                </FormDataConsumer>
                <DurationInput readOnly />
                <TextInput source="description" multiline fullWidth rows="4" />
            </SimpleForm>
        </Create>
    );
};

export default LeaveCreate;